import { Store } from 'src/store/index';

const getEditorBackgroundColor = (store: Store) => store.editor.backgroundColor;

export default getEditorBackgroundColor;
